module.exports = __webpack_public_path__ + "media/images/icons/outlined/delivered-procedure-dd85e45893c9d8abdeb539c3397dad47.svg";